import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import { isOptionEqualToValue } from 'feature/dispatching/utils';
import { useGetProductsBySupplierQuery, useGetSuppliersQuery } from '../../loadsEndpoints';
import LoadingTextField from './LoadingTextField';

const UnloadForm = ({ loadState, setLoadState, compartment }) => {
  const { location } = loadState;
  const { compartmentId, supplier, product } = compartment;

  const compartmentLens = R.lensPath(['compartments', compartmentId]);
  const supplierLens = R.compose(compartmentLens, R.lensProp('supplier'));
  const productLens = R.compose(compartmentLens, R.lensProp('product'));
  const volumeLens = R.compose(compartmentLens, R.lensProp('volume'));

  const {
    data: suppliersQuery = [],
    isFetching: isFetchingSuppliers,
    isSuccess: isSuppliersSuccess,
  } = useGetSuppliersQuery({ locationId: R.prop('locationId', location) });

  const {
    data: productsQuery = [],
    isFetching: isFetchingProducts,
    isSuccess: isProductsSuccess,
  } = useGetProductsBySupplierQuery(
    { supplierId: R.prop('supplierId', supplier) },
    { skip: R.isNil(supplier) }
  );

  const handleSupplierChange = (_, value) => {
    const updateSupplier = R.compose(
      R.set(productLens, null),
      R.set(supplierLens, value),
      R.set(volumeLens, '')
    );
    setLoadState(updateSupplier);
  };

  const handleProductChange = (_, value) => {
    // prettier-ignore
    const updateProduct = R.compose(
      R.set(productLens, value),
      R.set(volumeLens, '')
    );
    setLoadState(updateProduct);
  };

  return (
    <Stack spacing={2}>
      <Autocomplete
        disableClearable
        disabled={!isSuppliersSuccess}
        getOptionLabel={R.prop('name')}
        isOptionEqualToValue={isOptionEqualToValue('supplierId')}
        loading={isFetchingSuppliers}
        onChange={handleSupplierChange}
        options={suppliersQuery}
        renderInput={params => (
          <LoadingTextField label="Supplier" loading={isFetchingSuppliers} params={params} />
        )}
        value={supplier}
      />

      <Autocomplete
        disableClearable
        disabled={!isProductsSuccess}
        getOptionLabel={R.prop('name')}
        isOptionEqualToValue={isOptionEqualToValue('productId')}
        loading={isFetchingProducts}
        onChange={handleProductChange}
        options={productsQuery}
        renderInput={params => (
          <LoadingTextField label="Product" loading={isFetchingProducts} params={params} />
        )}
        value={product}
      />
    </Stack>
  );
};

UnloadForm.propTypes = {
  compartment: PropTypes.shape({
    compartmentId: PropTypes.number,
    product: PropTypes.shape({}),
    supplier: PropTypes.shape({}),
  }).isRequired,
  loadState: PropTypes.shape({
    location: PropTypes.shape({}),
  }).isRequired,
  setLoadState: PropTypes.func.isRequired,
};

export default UnloadForm;
